import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, of, catchError, throwError, BehaviorSubject } from 'rxjs';
import { REGION } from 'src/app/component/children/edit-child/ina/model/ina-service-administration';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';
import { WorkflowStateTypes1 } from '../model/workflow-state-types1.model';
import { Node } from 'src/app/component/node/model/node.model';
import { TransitionStorage} from 'src/app/component/system/workflows/model/transitions.model';

@Injectable({
    providedIn: 'root'
})
export class TransitionsService extends BaseRestApiService {

    private transitionStorageSubject = new BehaviorSubject(new TransitionStorage());
    transitionStorageSubject$ = this.transitionStorageSubject.asObservable();

    private transitionStorage = new TransitionStorage();

    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    indexTransitionPropertyTypes(): Observable<any> {
        return this.get<any>(EndPoints.transitions_IndexTransitionPropertyTypes).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    create(payload: any): Observable<any> {
        return this.post<any>(EndPoints.transitions_Create, false, null, { fromState: payload.fromState, role: payload.role, toState: payload.toState }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    deleteTransition(payload: any): Observable<any> {
        return this.post<any>(EndPoints.transitions_Delete, false, null, { fromState: payload.fromState, role: payload.role, toState: payload.toState }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    createTransitionProperty(payload: any): Observable<any> {
        return this.post<any>(EndPoints.transitions_CreateTransitionProperty, false, null, {
            transitionID: payload.transitionID,
            transitionPropertyType: payload.transitionPropertyType
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    deleteTransitionProperty(payload: any): Observable<any> {
        return this.post<any>(EndPoints.transitions_DeleteTransitionProperty, false, null, {
            transitionID: payload.transitionID,
            transitionPropertyType: payload.transitionPropertyType
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    toggleTransitionRegion(payload: any): Observable<any> {
        return this.post<any>(EndPoints.transitions_ToggleTransitionRegion, false, null, {
            region: payload.region,
            transitionPropertyType: payload.transitionPropertyType
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    indexUsersByRegion(node: Node, toState: WorkflowStateTypes1, region: REGION): Observable<any> {
        return this.post<any>(EndPoints.transitions_IndexUsersByRegion, false, null, {
            node: node, toState: toState, region: region
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    indexFixedUsersByRegion(node: Node, toState: WorkflowStateTypes1, region: REGION): Observable<any> {
        return this.post<any>(EndPoints.transitions_IndexFixedUsersByRegion, false, null, {
            node: node, toState: toState, region: region
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    //Node transition
    setTransitionStorageObject(transitionStorage: TransitionStorage) {
        this.transitionStorageSubject.next(transitionStorage)
    }

    setValid(flag: boolean) {
        this.transitionStorage.valid = flag;
    }

    setStateValid(stateName: string, flag: boolean) {
        this.transitionStorage.stateValid[stateName] = flag;
    }

    getMyTransitions(NodeId: number): Observable<any> {
        return this.get<any>(EndPoints.workflows_GetMyTransitions, null, NodeId).pipe(
            switchMap((result) => {
                return of(JSON.parse(JSON.stringify(result)));
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    /*nodesTransition(node: Node, toState: WorkflowStateTypes, assignUser: LoginDetails, message: string): Observable<any> {
        console.log("1",node)
        console.log("2",toState)
        console.log("3",assignUser)
        return this.post<any>(EndPoints.nodes_Transition, false, '', {
           node: node, toState: toState, assignToUser: assignUser
        });
    }*/
}
